/*
 * @Description: 
 * @Autor: wangwangwang
 * @Date: 2021-03-16 11:00:03
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-06-11 10:32:48
 */
export const queryPage = '/icps/system/sign/goodService/materialsRecycle/queryPagePc'
import request from '@/utils/request'
/**获取周材名列表*/
export function queryList(params) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringManagement/queryListMaterials',
    method: 'get',
    params
  })
}
/**通过工程查回收明细*/
export function queryDetailList(data) {
  return request({
    url: '/icps/system/sign/goodService/engineeringParticulars/queryPage',
    method: 'post',
    data
  })
}
/**通过回收明细查周材明细*/
export function queryChangeResord(data) {
  return request({
    url: '/icps/system/sign/goodService/engineeringParticulars/queryChangeResord',
    method: 'post',
    data
  })
}
/**周材回收-保存*/
export function saveRcycleResord(data) {
  return request({
    url: '/icps/system/sign/goodService/materialsRecycle/saveRcycleResord',
    method: 'post',
    data
  })
}
/**周材回收-保存*/
export function transferMaterials(data) {
  return request({
    url: '/icps/system/sign/goodService/materialsRecycle/transferMaterials',
    method: 'post',
    data
  })
}
/**自用-获取出库单列表*/
export function queryStockOutNumber(data) {
  return request({
    url: '/icps/system/sign/goodService/outStorage/queryStockOutNumber',
    method: 'post',
    data
  })
}
/**通过回收ID获取回收明细和人员车辆*/
export function queryRecycleAll(data) {
  return request({
    url: '/icps/system/sign/goodService/materialsRecycle/queryRecycleAll',
    method: 'post',
    data
  })
}

/**周材明细调整*/
export function updateChangeResord(data) {
  return request({
    url: '/icps/system/sign/goodService/engineeringParticulars/updateChangeResord',
    method: 'post',
    data
  })
}

/**修改回收记录*/
export function updateRcycleResord(data) {
  return request({
    url: '/icps/system/sign/goodService/materialsRecycle/updateRcycleResord',
    method: 'post',
    data
  })
}

/**获取运输记录*/
export function queryPageApp(data) {
  return request({
    url: '/icps/system/sign/goodService/materialsTransport/queryPageApp',
    method: 'post',
    data
  })
}

/**获取运输记录*/
export function transportDetails(data) {
  return request({
    url: '/icps/system/sign/goodService/transportDetails/queryPageApp',
    method: 'post',
    data
  })
}

/**获取运输记录*/
export function queryCarLIst(data) {
  return request({
    url: '/icps/system/sign/goodService/materialsRecycle/queryCarLIst',
    method: 'post',
    data
  })
}

/**修改运输记录*/
export function updateTransport(data) {
  return request({
    url: '/icps/system/sign/goodService/materialsTransport/updateTransport',
    method: 'post',
    data
  })
}
